import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { isUser } from "../../Config/isUser";
import NotFoundPage from "../../Pages/NotFoundPage";

const ApplyPost = () => {
  const { id } = useParams(); // id parametre olarak alındı
  const [post, setPost] = useState(null); // Post başlangıçta null
  const [company, setCompany] = useState(null); // Post başlangıçta null
  const [notFound, setNotFound] = useState(false); // İlan bulunamazsa

  useEffect(() => {
    const fetchPost = async () => {
      try {
        // İlk API çağrısı
        const response = await axios.get(
          `https://kariyer.biyomed.net/api/posts/getOnePost/${id}`
        );

        const post = response.data.post;

        // İkinci API çağrısı (company_id ile)
        const res = await axios.post(
          "https://kariyer.biyomed.net/api/companies/getOneDetailsCard",
          { company_id: post.company_id }
        );

        const companyDetails = res.data.company;
        // İki API'den gelen verileri birleştir ve state'e ata
        setPost(post);
        setCompany(companyDetails);
      } catch (err) {
        console.error("Error fetching post:", err);
        setNotFound(true);
      }
    };

    fetchPost(); // Fetch fonksiyonunu çağır
  }, [id]); // Sadece id değiştiğinde isteği tekrar gönder

  const applyPost = async (e, postId) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://kariyer.biyomed.net/api/posts/apply-post",
        {
          post_id: postId,
        },
        { withCredentials: true }
      );
      console.log(response.data.message);
      alert("Başvurunuz iletilmiştir")
      window.location.href = "/my-applied-posts"
    } catch (err) {
      console.error("Error applying post:", err.response.data.message);
      alert("Başvururken hata: " + (err.response?.data?.message || err.message));
    }
  };

  const formattedDate = new Date(post?.created_at).toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const handleClick = (e, id) => {
    e.preventDefault();
    if (id) {
      window.location.href = `companyinfo/${id}`
    }

  }

  return (
    <>{notFound ? <NotFoundPage /> :


      <>
        <div className="jp_tittle_main_wrapper">
          <div className="jp_tittle_img_overlay" />
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_tittle_heading_wrapper">
                  <div className="jp_tittle_heading">
                    <h2>{post?.position_name}</h2>
                  </div>
                  <div className="jp_tittle_breadcrumb_main_wrapper">
                    <div className="jp_tittle_breadcrumb_wrapper">
                      <ul>
                        <li>
                          <a href="/">Anasayfa</a> <i className="fa fa-angle-right" />
                        </li>
                        <li>
                          <a href="/all-posts">Tüm İlanlar</a> <i className="fa fa-angle-right" />
                        </li>
                        <li>{post?.position_name}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="jp_listing_single_main_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div className="jp_listing_left_sidebar_wrapper">
                  {post?.required_qualifications ? <div className="jp_job_apply" style={{marginTop:-40}}>
                    <h2>Aranan Nİtelİkler</h2>
                    <div dangerouslySetInnerHTML={{ __html: post?.required_qualifications }} />
                  </div> : ""}

                  {post?.job_description ? <div className="jp_job_apply">
                    <h2>İş Tanımı/Sorumluluklar</h2>
                    <div dangerouslySetInnerHTML={{ __html: post?.job_description }} />
                  </div> : ""}

                  {post?.other_comments ?
                    <div className="jp_job_apply">
                      <h2>DİĞER BİLGİLER</h2>
                      <div dangerouslySetInnerHTML={{ __html: post?.other_comments }} />
                      {post?.job_link ? <div style={{ marginTop: 20 }}>
                      </div> : ''}
                    </div> : ""
                  }
                  <div className="jp_job_apply">
                    <h2>Hakkımızda</h2>
                    <div style={{ marginTop: 10 }} dangerouslySetInnerHTML={{ __html: post?.company_about }} />
                  </div>
                </div>
                <div className="jp_listing_left_bottom_sidebar_key_wrapper">
                  <ul>
                    <li>
                      <i className="fa fa-tags" />
                      Etiketler:
                    </li>
                    <li>
                      <a href="/">{post?.position_tags}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="jp_rightside_job_categories_wrapper jp_rightside_listing_single_wrapper">
                      <div className="jp_rightside_job_categories_heading">
                        <h4>İlan Bilgileri</h4>
                      </div>
                      <div className="jp_jop_overview_img_wrapper">
                        <div className="jp_jop_overview_img">
                          <img
                            src={company?.profile_image}
                            alt="post_img"
                            style={{
                              maxWidth: "90%",
                              maxHeight: "200px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </div>
                      <div className="jp_job_listing_single_post_right_cont">
                        <div className="jp_job_listing_single_post_right_cont_wrapper">
                          <h4>{post?.position_name}</h4>
                          <p
                  onClick={(e) => handleClick(e, post?.company_id)}
                  onMouseEnter={(e) => (e.target.style.color = "black")}
                  onMouseLeave={(e) => (e.target.style.color = "#23c0e9")}
                  style={{
                    fontSize: "14px",
                    marginTop: 10,
                    cursor: "pointer",
                    color: "#23c0e9", // Varsayılan renk
                    transition: "color 0.2s ease-in-out", // Yumuşak geçiş efekti
                  }}
                >
                  {post?.company_name?.length > 40 ? post?.company_name.slice(0, 40) + "..." : post?.company_name}
                </p>
                        </div>
                      </div>
                      <div className="jp_job_post_right_overview_btn_wrapper">
                        <div className="jp_job_post_right_overview_btn">
                          <ul>
                            <li>
                            </li>
                            <li>
                              <a style={{ backgroundColor: post?.job_type === "Is" ? '' : '#f7b248', marginRight: 20 }} href="/">
                                {post?.job_type === "Is" ? "İş İlanı" : post?.job_type === "Staj" ? "Staj İlanı" : post?.job_type}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="jp_listing_overview_list_outside_main_wrapper">
                        <div className="jp_listing_overview_list_main_wrapper">
                          <div className="jp_listing_list_icon">
                            <i className="fa fa-calendar" />
                          </div>
                          <div className="jp_listing_list_icon_cont_wrapper">
                            <ul>
                              <li>Yayımlama Tarihi:</li>
                              <li>{formattedDate}</li>
                            </ul>
                          </div>
                        </div>
                        <div className="jp_listing_overview_list_main_wrapper jp_listing_overview_list_main_wrapper2">
                          <div className="jp_listing_list_icon">
                            <i className="fa fa-map-marker" />
                          </div>
                          <div className="jp_listing_list_icon_cont_wrapper">
                            <ul>
                              <li>İl:</li>
                              <li>{post?.city}</li>
                            </ul>
                          </div>
                        </div>
                        <div className="jp_listing_overview_list_main_wrapper jp_listing_overview_list_main_wrapper2">
                          <div className="jp_listing_list_icon">
                            <i className="fa fa-info-circle" />
                          </div>
                          <div className="jp_listing_list_icon_cont_wrapper">
                            <ul>
                              <li>Pozisyon Tanımı</li>
                              <li>{post?.position_name}</li>
                            </ul>
                          </div>
                        </div>
                        <div className="jp_listing_overview_list_main_wrapper jp_listing_overview_list_main_wrapper2">
                          <div className="jp_listing_list_icon">
                            <i className="fa fa-clock-o" />
                          </div>
                          <div className="jp_listing_list_icon_cont_wrapper">
                            <ul>
                              <li>Çalışma Şekli</li>
                              <li>{post?.work_style === "Is yerinde" ? 'İş Yerinde' : (post?.work_style === "Hibrid" ? "Hibrid" : "Uzaktan")}</li>
                            </ul>
                          </div>
                        </div>
                        <div className="jp_listing_overview_list_main_wrapper jp_listing_overview_list_main_wrapper2">
                          <div className="jp_listing_list_icon">
                            <i className="fa fa-th-large" />
                          </div>
                          <div className="jp_listing_list_icon_cont_wrapper">
                            <ul>
                              <li>Kategori</li>
                              <li>{post?.position_category}</li>
                            </ul>
                          </div>
                        </div>
                        <div className="jp_listing_overview_list_main_wrapper jp_listing_overview_list_main_wrapper2">
                          <div className="jp_listing_list_icon">
                            <i className="fa fa-star" />
                          </div>
                          <div className="jp_listing_list_icon_cont_wrapper">
                            <ul>
                              <li>Deneyim</li>
                              <li>{post?.required_experience} yıl deneyim</li>
                            </ul>
                          </div>
                        </div>
                        <div className="jp_listing_right_bar_btn_wrapper">
                          <div className="jp_listing_right_bar_btn">
                            <ul>
                              <li>
                                {" "}
                                {isUser ? (
                                  <a
                                    onClick={(e) => {
                                      applyPost(e, post.id);
                                    }}
                                    href="/"
                                  >
                                    <i className="fa fa-plus-circle" /> &nbsp;İşe
                                    başvur
                                  </a>
                                ) : (
                                  <>
                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        window.location.href = "/login";
                                      }}
                                      href="/login"
                                    >
                                      <i className="fa fa-plus-circle" /> &nbsp;İşe
                                      başvur
                                    </a>
                                    <p
                                      style={{
                                        marginTop: 12,
                                        fontSize: "13px",
                                        color: "#f7431f",
                                        textAlign: "center",
                                      }}
                                    >
                                      Başvurmanız için giriş yapmanız
                                      gerekmektedir.
                                    </p>
                                  </>
                                )}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div></>
      }</>

  );
};

export default ApplyPost;

